// extracted by mini-css-extract-plugin
export default {"popup_overlay":"popup_popup_overlay__K2jJr","popup":"popup_popup__x+ew0","close":"popup_close__1nEAr","logo":"popup_logo__5FMCL"};